import React from 'react';
import ButtonGeneral from '../../../components/buttons/ButtonGeneral';
import { LawyerPlan, formatCLP, limitText, WHITE_LABEL_LABELS } from '../types';

interface Props {
    plan: LawyerPlan;
    isCurrent?: boolean;
    selected?: boolean;
    actionLabel?: string;
    actionDisabled?: boolean;
    loading?: boolean;
    onAction?: () => void;
}

/** Tarjeta de un plan de abogados (registro y Mi Estudio). */
const PlanCard: React.FC<Props> = ({ plan, isCurrent, selected, actionLabel, actionDisabled, loading, onAction }) => (
    <div className={`card h-100 ${selected || isCurrent ? 'border-primary border-2' : ''}`} data-testid={`plan-${plan.code}`}>
        <div className="card-body d-flex flex-column">
            <div className="d-flex justify-content-between align-items-start mb-2">
                <h5 className="mb-0">{plan.name}</h5>
                {isCurrent ? (
                    <span className="badge bg-success">Actual</span>
                ) : plan.badge_text ? (
                    <span className="badge bg-primary">{plan.badge_text}</span>
                ) : null}
            </div>
            <div className="mb-2">
                {plan.is_free ? (
                    <span className="fs-3 fw-bold">Gratis</span>
                ) : (
                    <>
                        <span className="fs-3 fw-bold">{formatCLP(plan.price_with_tax)}</span>
                        <span className="text-muted small"> / mes IVA incl.</span>
                    </>
                )}
            </div>
            {plan.short_description && <p className="text-muted small">{plan.short_description}</p>}
            <ul className="list-unstyled small mb-3 flex-grow-1">
                <li className="mb-1"><i className="fas fa-users me-2 text-primary" />{plan.max_seats === -1 ? 'Usuarios ilimitados' : `${plan.max_seats} usuario(s)`}</li>
                <li className="mb-1"><i className="fas fa-address-book me-2 text-primary" />{limitText(plan.max_clients)} clientes en cartera</li>
                <li className="mb-1"><i className="fas fa-trademark me-2 text-primary" />{limitText(plan.max_brand_applications)} marcas en curso</li>
                <li className="mb-1"><i className="fas fa-palette me-2 text-primary" />{WHITE_LABEL_LABELS[plan.white_label_level]}</li>
                <li className="mb-1"><i className="fas fa-headset me-2 text-primary" />Soporte {plan.support_level_display.toLowerCase()}</li>
                {plan.features.slice(0, 3).map((feature) => (
                    <li key={feature} className="mb-1 text-muted"><i className="fas fa-check me-2" />{feature}</li>
                ))}
            </ul>
            {actionLabel && onAction && (
                <ButtonGeneral onClick={onAction} title={actionLabel} disabled={actionDisabled} loading={loading}
                               fullWidth variant={isCurrent ? 'outline' : 'primary'} />
            )}
        </div>
    </div>
);

export default PlanCard;
